import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment.dev';
import { Client } from '../models/client';

/**
 * Sends lead registrations from the public landing forms to the affiliates service.
 */
@Injectable({
	providedIn: 'root',
})
export class RegisterFormService {
	private urlApi = environment.urlApi;

	constructor(private http: HttpClient) {}

	/**
	 * Registers an external client (lead) captured by a landing form.
	 *
	 * The request carries the shared `hash-code`, the Turnstile `captcha-token`
	 * that proves the submission came from a person, and the visitor's language
	 * so the backend localizes its response messages.
	 *
	 * @param client Lead data collected by the form.
	 * @param captchaToken Single-use token produced by the Turnstile widget for this submission.
	 * @returns The confirmation message returned by the backend.
	 */
	public registerClient(client: Client, captchaToken: string): Observable<{ message: string }> {
		const currentLanguage = localStorage.getItem('language') ?? 'en';
		const headers = new HttpHeaders()
			.set('hash-code', 'aGFzaC1jbGllbnQtcGVudHZpZXc')
			.set('captcha-token', captchaToken)
			.set('Accept-Language', currentLanguage);

		return this.http.post<{ message: string }>(`${this.urlApi}/ms-affiliates/external-register/client`, client, { headers });
	}
}
